import styled from "styled-components";

export const StyledBodyInternalGrade = styled.div<{
  $isComparisonComponent?: boolean;
}>`
  & > div:not(:last-child) {
    width: auto;
  }

  & .internal-grade-bordered-container {
    margin-top: ${({ $isComparisonComponent }) =>
      !$isComparisonComponent ? "30px" : "20px"};
  }
`;

export const StyledColumnContainer = styled.div<{
  $isComparisonComponent?: boolean;
}>`
  display: flex;
  flex-direction: ${({ $isComparisonComponent }) =>
    !$isComparisonComponent ? "column" : "row"};
  gap: 20px;
`;
